<app-page-title [title]="'ACCOUNT LINK REQUEST'"></app-page-title>

<div class="row reviewOrder">
    <div class="col-md-12">
        <p>
            <strong> {{ businessName }} </strong> has requested permission to manage your account.
            Please read and agree to the following service terms if you wish to accept this change to your account.
        </p>
        <div class="terms-and-conditions">
            <div [innerHtml]="serviceTerm"></div>
        </div>
    </div>
</div>
<br />
<form
    name="accept-adoption-form"
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
>

    <div class="row">
        <div>
            <div class="form-group">
                <div>
                    <div class="checkbox">
                        <input
                            type="checkbox"
                            name="agreement"
                            formControlName="agreement"
                            class="checkbox-space"
                            autofocus
                        />
                        <span>I certify that I have read and agree to the Service Terms above.</span>
                    </div>
                </div>
                <br />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <button
                    class="btn btn-primary"
                    type="submit"
                    name="confirmationYesBtn"
                >
                    Accept Changes
                </button>
            </div>
        </div>
    </div>
</form>
